export const downloadBase64Csv = (base64Content: string, fileName: string) => {
  let csvContent = base64Content;

  try {
    const sanitizedBase64 = base64Content.includes(',')
      ? (base64Content.split(',').pop() ?? '')
      : base64Content;

    // Remove whitespace/new lines often present in base64 payloads.
    const normalizedBase64 = sanitizedBase64.replace(/\s/g, '');
    csvContent = window.atob(normalizedBase64);
  } catch {
    // If decoding fails, assume response is already CSV text.
    csvContent = base64Content;
  }

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const downloadUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');

  anchor.href = downloadUrl;
  anchor.download = fileName;

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(downloadUrl);
};
